import i18n from 'i18n';

export const getTransactionStatusInfo = (status) => {
	if (!status) return i18n.t('transaction_verification_modal_status_loading');
	return i18n.t(`trasaction_verification_modal_status_${status}`);
};
